angular.module('Itao.HyperionAtlas').service('LoadingInterceptor', ['$q',
  function ($q) {
    'use strict';

    var ignoredUrls = ['items_renderer.html'];
    var openRequests = 0;
    var $overlay = jQuery('#loadingoverlay');
    var overlayTimeout;

    /**
     * check if the request/response is relevant for showing the loading overlay
     *
     * @param {object} config configObject of the request/response
     * @returns {boolean}
     */
    function isRelevant(config) {
      return ignoredUrls.indexOf(config.url) === -1;
    }


    /**
     * update the status of the loading overlay
     */
    function updateStatus() {
      if(openRequests > 0) {
        $overlay.addClass('show');
      } else {
        $overlay.removeClass('show');
      }
    }

    /**
     * update the timeout
     * this timeout is used to prevent flickering and showing the overlay for very short requests
     *
     * @param {integer} mseconds number of milliseconds to wait
     */
    function updateTimeout(mseconds) {
      if(overlayTimeout != null) {
        clearTimeout(overlayTimeout);
      }

      overlayTimeout = setTimeout(updateStatus, mseconds);

    }

    return {
      request: function (config) {
        if(isRelevant(config)) {
          openRequests++;
          updateTimeout(100);
        }
        return config;
      },
      requestError: function (rejection) {
        openRequests--;
        updateTimeout(0);
        return $q.reject(rejection);
      },
      response: function (response) {
        if(isRelevant(response.config)) {
          openRequests--;
          updateTimeout(200);
        }
        return response;
      },
      responseError: function (rejection) {
        openRequests--;
        updateTimeout(0);
        return $q.reject(rejection);
      }
    };
  }]);
